var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HelperView',{attrs:{"type":_vm.type,"icon":_vm.icon,"title":_vm.title,"description":_vm.description,"button-label":"Ver minhas ordens"},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }